import 'css-chunksrc/client/scenes/projectStrategicAxes/projectStrategicAxesTable/projectStrategicAxisEdition/tag/styles.scss';export default {
  "tag": "_tag_b438t_1"
};